import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonService } from "../../common-service";
import { ListPatientAppointmentResponse } from "../../responses/schedule/list-patient-appointment.response";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { PaginatedPatientAppointmentRequest } from "../../requests/schedule/paginated-patient-appointment.request";

@Injectable({
    providedIn: 'root'
})
export class PatientCenterAppointmentService extends CommonService {

    constructor(private httpClient: HttpClient) { super(); }

    public getPatientAppointment(request: PaginatedPatientAppointmentRequest): Observable<ListPatientAppointmentResponse> {
        let uri = `PatientCenterAppointment/getAll`;

        return this.httpClient.post<ListPatientAppointmentResponse>(environment.urlApiOrchestratorSchedule + uri, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}